import { setLocation } from 'js/lib/coursera.redirect';

import GrowthAcquisitionExperiments from 'bundles/epic/clients/GrowthAcquisition';

export const enableOnboardingModalBackendFixTest = () =>
  GrowthAcquisitionExperiments.get('enableOnboardingModalBackendFix');

export const redirectToOnboardingIfNecessary = ({
  hasSeenOnboarding,
  loading,
}: {
  hasSeenOnboarding?: boolean;
  loading?: boolean;
}) => {
  if (enableOnboardingModalBackendFixTest() && loading === false && hasSeenOnboarding === false) {
    setLocation('/onboarding-2022');
  }
};

export default {
  enableOnboardingModalBackendFixTest,
  redirectToOnboardingIfNecessary,
};
